import { COLOR_PALETTE } from 'constants/ui';

export const cardListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginTop: '8px',
};

export const cardContainerStyles = {
  backgroundColor: COLOR_PALETTE.ORANGE[1],
  borderRadius: '4px 8px 8px 4px',
  overflow: 'hidden',
  padding: '16px 16px 16px 20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  position: 'relative',
  boxShadow: ({ palette }) => palette.shadow?.s ?? '0px 1px 4px 0px rgba(18, 23, 29, 0.15)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: '4px',
    backgroundColor: COLOR_PALETTE.ORANGE[7],
    borderRadius: '4px 0 0 4px',
  },
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
};

export const iconContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  color: COLOR_PALETTE.ORANGE[7],
};

export const contentStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  flex: 1,
  minWidth: 0,
};

export const titleStyles = {
  color: COLOR_PALETTE.ORANGE[7],
};

export const iconStyles = {
  color: COLOR_PALETTE.ORANGE[7],
};

export const successIconStyles = {
  color: COLOR_PALETTE.GREEN[6],
};

export const errorIconStyles = {
  color: COLOR_PALETTE.RED[6],
};

export const detailStyles = {
  color: ({ palette }) => palette.text.dark,
  wordBreak: 'break-word',
};

export const statusContainerStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
};

export const resultTextStyles = {
  color: ({ palette }) => palette.text.dark,
  wordBreak: 'break-word',
};

export const resultFullStyles = {
  color: ({ palette }) => palette.text.dark,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};

export const errorTextStyles = {
  color: COLOR_PALETTE.RED[7],
  wordBreak: 'break-word',
};

export const cancelledTextStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const timedOutTextStyles = {
  color: COLOR_PALETTE.ORANGE[7],
};

export const adjustSummaryStyles = {
  flex: 1,
  minWidth: 0,
  color: ({ palette }) => palette.text.secondary,
};

export const showMoreButtonStyles = {
  alignSelf: 'flex-start',
  padding: 0,
  minWidth: 'auto',
  backgroundColor: 'transparent',
  color: COLOR_PALETTE.BLUE[6],
  cursor: 'pointer',
  border: 'none',
  font: 'inherit',
  textDecoration: 'underline',
};
